<template>
  <div class="content">
    <div class="get-today-consume-cetail" @click="todayConsumeActive=true">今日消费明细</div>
    <div class="top">
      <img class="logo" src="../assets/logo.png" alt />
      <div class="all-money">
        <!-- <img src="../assets/money.png" alt /> -->
        <lottie :options="defaultOptions" :height="160" :width="160" v-on:animCreated="handleAnimation"/>
        <div class="all-money-content">
          <p
            class="all-money-text"
          >今日总收入{{incomeData.coffeeAllMoney || incomeData.receptionAllMoney || 0}}元</p>
          <p
            class="all-money-text"
          >今日共计消费{{incomeData.coffeeAllTicketNum || incomeData.receptionAllTicketNum || 0}}张优惠券</p>
        </div>
      </div>
    </div>
    <div class="main">
      <div class="left">
        <p class="title" style="margin-top: 20px;">用户ID</p>
        <div class="input">
          <input class="id" @input="inputCode" v-model="id" autofocus="autofocus" maxlength="14" />
        </div>
        <div class="sure-box" v-show="msgShow">
          <p class="title" style="margin-top: 20px;">请输入消费金额</p>
          <div class="input">
            <input class="number" v-model="input" />
            <p class="input-text">元</p>
          </div>
          <div class="sure" @click="pay">确认</div>
        </div>
      </div>
      <div class="right" v-show="msgShow">
        <div class="userinfo">
          <div class="userinfo-left">
            <img :src="userInfo.avatar" alt class="avatar" />
          </div>
          <div class="userinfo-right">
            <p class="text id-num">会员卡号：{{userInfo.member_code}}</p>
            <p class="text mobile-phone">手机号：{{userInfo.mobilePhone}}</p>
            <p class="text id-name">姓名：{{userInfo.idName}}</p>
            <p class="text balance">余额：{{userInfo.balance || '0元'}}</p>
            <p class="text is-membership">会员类型：{{userInfo.vipType}}</p>
          </div>
        </div>
        <div class="tickets">
          <div
            v-for="(val, index) in ticketList"
            :key="index"
            class="ticket"
            :class="[activeIndex===index && 'ticket-active']"
            @click="chooseTicket(val.id,index)"
          >
            <div class="ticket-left">
              <img :src="val.ticketImg" alt />
            </div>
            <div class="ticket-right">
              <div class="ticket-name">{{val.ticketName}} X1</div>
              <div class="ticket-money">价值: ￥{{val.ticketPrice}}</div>
              <div class="ticket-time">过期时间: {{val.ticketTime}}</div>
            </div>
            <div class="ticket-use">
              <p>未使用</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 123456789.0{del:backspace}{space:space} -->
    <keyboard
      v-show="msgShow"
      v-model="input"
      type="number"
      @custom="custom"
      @input="changed"
      :layouts="[
      '123456789.0{del:backspace}'
    ]"
      :maxlength="16"
    ></keyboard>
    <div class="loading" v-show="loadingShow">
      <div class="spinner">
        <div class="double-bounce1"></div>
        <div class="double-bounce2"></div>
      </div>
    </div>
    <div class="confirm" v-show="confirmShow">
      <div class="confirm-main" :class="[activeIndex!==undefined?'confirm-active':'']">
        <p class="confirm-main-title">确认订单</p>
        <p class="title-desc">{{userInfo.idName}}消费{{input}}元</p>
        <p
          class="title-desc"
          v-if="activeIndex!==undefined"
        >使用【{{ticketList[activeIndex].ticketName}}】一张</p>
        <div class="buttons">
          <div class="button-left" @click="payEsc">取消</div>
          <div class="button-right" @click="paySure">确认</div>
        </div>
      </div>
    </div>
    <div class="order-box" v-show="paySuccess">
      <div class="order">
        <div class="order-top">
          <div class="order-top-title">
            <img :src="!payError?successPng:errorPng" alt class="order-title-img" />
            <p class="order-title-text">{{!payError?'支付成功':'支付失败'}}</p>
          </div>
          <div class="order-subtitle">实付¥{{input}}</div>
        </div>
        <div class="order-main">
          <div class="order-line">
            <p class="order-name">姓名</p>
            <p class="order-name-text order-name-n">{{userInfo.idName}}</p>
          </div>
          <div class="order-line">
            <p class="order-name">电话</p>
            <p class="order-name-text order-name-f">{{userInfo.mobilePhone}}</p>
          </div>
          <div class="order-line">
            <p class="order-name">消费金额</p>
            <p class="order-name-text order-name-m" style="color: #DBA256;">¥ {{input}}</p>
          </div>
          <div class="order-line" v-show="payError">
            <p class="order-name">失败原因</p>
            <p class="order-name-text order-name-m" style="color: red;">{{payErrorMsg}}</p>
          </div>
          <div class="order-line" v-show="!payError">
            <p class="order-name">余额</p>
            <p
              class="order-name-text order-name-z"
              style="color: #DBA256;"
            >¥ {{payResultMsg.balance}}</p>
          </div>
        </div>
        <div class="order-button" @click="paySuccssFun">确认</div>
      </div>
    </div>
    <div class="today-consume-cetail" :class="[todayConsumeActive&&'today-consume-cetail-active']">
      <p class="today-consume-close" @click="todayConsumeActive=false">X</p>
      <p></p>
      <div class="today-consume-title">消费明细</div>
      <div class="today-consume-header">
        <p>日期</p>
        <p>姓名</p>
        <p>手机号</p>
        <p>消费</p>
      </div>
      <div class="today-consume-body" v-for="(item,index) in todayConsume" :key="index">
        <p>{{item.time}}</p>
        <p>{{item.userName}}</p>
        <p>{{item.userTel}}</p>
        <p>{{item.money}}{{item.goodsName?('【'+item.goodsName+'X1】'):''}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import successPng from "../assets/success.png";
import errorPng from "../assets/error.png";
import Lottie from "vue-lottie";
import * as animationData from "../assets/lottie.json";
Date.prototype.format = function(format) {
  var date = {
    "M+": this.getMonth() + 1,
    "d+": this.getDate(),
    "h+": this.getHours(),
    "m+": this.getMinutes(),
    "s+": this.getSeconds(),
    "q+": Math.floor((this.getMonth() + 3) / 3),
    "S+": this.getMilliseconds()
  };
  if (/(y+)/i.test(format)) {
    format = format.replace(
      RegExp.$1,
      (this.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  for (var k in date) {
    if (new RegExp("(" + k + ")").test(format)) {
      format = format.replace(
        RegExp.$1,
        RegExp.$1.length == 1
          ? date[k]
          : ("00" + date[k]).substr(("" + date[k]).length)
      );
    }
  }
  return format;
};
import {
  getUserMsg,
  getMycapital,
  payMement,
  income,
  consumeDetail
} from "@/api/index";
import keyboard from "./vue-keyboard";
export default {
  name: "Restaurant",
  components: { keyboard ,'lottie': Lottie},
  data() {
    return {
      successPng,
      errorPng,
      input: "",
      token: "",
      id: undefined, // 输入 token + 用户id
      money: 1000,
      userInfo: {},
      msgShow: false,
      inputValue: 0,
      ticketList: [],
      ticketId: undefined,
      activeIndex: undefined,
      consumePlace: undefined,
      loadingShow: false,
      incomeData: {
        coffeeAllMoney: 0,
        coffeeAllTicketNum: 0,
        receptionAllMoney: 0,
        receptionAllTicketNum: 0
      },
      confirmShow: false,
      paySuccess: false,
      payResultMsg: {},
      todayConsume: [],
      todayConsumeActive: false,
      payError: false,
      payErrorMsg: "",
      defaultOptions: { animationData }
    };
  },
  methods: {
    handleAnimation: function(anim) {
      this.anim = anim;
    },
    sortTickets(ticketArr) {
      let compare = pro => {
        return function(obj1, obj2) {
          var val1 = obj1[pro];
          var val2 = obj2[pro];
          if (val1 < val2) {
            //正序
            return -1;
          } else if (val1 > val2) {
            return 1;
          } else {
            return 0;
          }
        };
      };
      ticketArr.sort(compare("expiresDate"));
      ticketArr.forEach(item => {
        item.ticketTime = new Date(item.expiresDate).format(
          "yyyy-MM-dd hh:mm:ss"
        );
      });
      this.ticketList = ticketArr;
      this.loadingShow = false;
    },
    getMycapital(id) {
      getMycapital({
        id,
        ticketType: this.consumePlace == "31" ? undefined : 1
      })
        .then(response => {
          this.msgShow = true;
          let data = response.memberInfo;
          // 0潜在会员，1非潜在会员 staff 公司员工
          // isMembership 1 会员 0 潜在会员
          if (data.isMembership === "1") {
            if (data.member_level === "staff") {
              data.vipType = "公司员工";
            } else {
              data.vipType = "清泉会员";
            }
          } else {
            data.vipType = "潜在会员";
          }
          this.userInfo = data;

          let ticketsArr = [
            ...response.coffeeTicketList,
            ...response.placeTicketList
          ];
          this.sortTickets(ticketsArr);
        })
        .catch(() => {
          console.log("错误");
          this.loadingShow = false;
        });
    },
    inputCode() {
      if (this.id.length === 14) {
        let idArr = this.id.split(" "),
          id = idArr[idArr.length - 1];
        this.token = idArr[0];
        this.getMycapital(id);
        this.loadingShow = true;
      }
    },
    changed(value) {
      console.log("Value " + value);
    },

    custom(keyboard) {
      console.log(keyboard.value);
    },

    payResult() {
      let formData = {
        id: this.userInfo.id,
        consumeMoney: this.input,
        ticketUserId: this.ticketId,
        consumePlace: this.consumePlace,
        token: this.token
      };
      payMement(formData)
        .then(response => {
          console.log(response.success);
          if (!response.success) {
            // window.location.reload();
            // alert(response.msg)
            this.payError = true;
            this.payErrorMsg = response.msg;
            this.paySuccess = true;
            return;
          }
          this.paySuccess = true;
          this.payResultMsg = response;
          this.income();
          this.consumeDetail();
          this.getMycapital(this.userInfo.id);
        })
        .catch(() => {
          console.log("错误");
        });
    },

    pay() {
      this.confirmShow = true;
    },

    chooseTicket(id, index) {
      if (this.activeIndex === index) {
        this.activeIndex = undefined;
        this.ticketId = undefined;
        return;
      }
      this.activeIndex = index;
      this.ticketId = id;
    },

    /**
     * 消费总额
     */
    income() {
      income({ consumePlace: this.consumePlace })
        .then(response => {
          this.incomeData = response;
        })
        .catch(() => {
          console.log("错误");
        });
    },

    /**
     * 支付取消
     */
    payEsc() {
      this.confirmShow = false;
    },

    /**
     * 支付确认
     */
    paySure() {
      this.confirmShow = false;
      this.payResult();
    },

    /**
     * 取消
     */
    paySuccssFun() {
      this.paySuccess = false;
      window.location.reload();
    },

    /**
     * 获取 今日消费明细
     */
    consumeDetail() {
      consumeDetail({ consumePlace: this.consumePlace })
        .then(response => {
          response.forEach(item => {
            item.time = new Date(item.addTime).format("yyyy-MM-dd hh:mm:ss");
          });
          this.todayConsume = response;
        })
        .catch(() => {
          console.log("错误");
        });
    }
  },
  mounted() {
    this.consumePlace = this.$route.query.consumePlace;
    this.income();
    this.consumeDetail();
  }
};
</script>

<style>
.top {
  width: 100%;
  height: 100px;
  background: #ffffff;
  overflow: hidden;
  position: relative;
}

.all-money {
  height: 100px;
  position: absolute;
  right: 30px;
  top: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
}

.all-money img {
  width: 60px;
  height: 60px;
}

.all-money .all-money-content {
  font-size: 16px;
  margin-left: -35px;
}

.logo {
  width: 305px;
  height: 58px;
  display: block;
  margin: 20px auto 0;
}

.main {
  width: 860px;
  height: 450px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.left {
  width: 490px;
}

.title {
  font-size: 30px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: #ffffff;
  margin-top: 128px;
}

.input {
  width: 488px;
  height: 66px;
  border: 2px solid rgba(255, 255, 255, 1);
  border-radius: 2px;
  position: relative;
  margin-top: 22px;
}

.id {
  width: 470px;
  height: 66px;
  background: none;
  border: none;
  outline: none;
  overflow: hidden;
  font-size: 36px;
  padding-left: 20px;
  color: #ffffff;
}

.number {
  width: 470px;
  height: 66px;
  background: none;
  border: none;
  outline: none;
  overflow: hidden;
  font-size: 36px;
  padding-left: 20px;
  color: #ffffff;
}

.input-text {
  position: absolute;
  right: 21px;
  top: 50%;
  margin-top: -43px;
  line-height: 86px;
  font-size: 36px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: #ffffff;
}

.sure {
  width: 490px;
  line-height: 66px;
  text-align: center;
  background: #dba256;
  border-radius: 2px;
  font-size: 26px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: #ffffff;
  margin-top: 29px;
}

.right {
  margin-left: 52px;
}

.userinfo {
  display: flex;
}

.userinfo-right {
  margin-left: 15px;
}

.avatar {
  width: 68px;
  height: 68px;
  border-radius: 50%;
  display: block;
  margin-bottom: 10px;
}

.right .text {
  font-size: 16px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 28px;
}

.tickets {
  height: 250px;
  overflow-y: scroll;
  position: relative;
  margin-top: 10px;
}

.ticket {
  width: 300px;
  height: 80px;
  background: #ffffff;
  margin-bottom: 10px;
  border-radius: 3px;
  display: flex;
  position: relative;
  border: 4px solid #ffffff;
}

.ticket-active {
  border: 4px solid #dba256;
  background: #dba256;
}

.ticket-left {
  width: 80px;
  border-right: 1px dotted #cccccc;
  display: flex;
  justify-content: center;
  align-items: center;
}

.ticket-left img {
  width: 30px;
  height: 50px;
}

.ticket-right {
  width: 260px;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.ticket-name {
  color: #303030;
  font-size: 16px;
  margin-left: 10px;
}

.ticket-money {
  color: #e95060;
  font-size: 14px;
  margin-top: 2px;
  margin-left: 10px;
}

.ticket-time {
  color: #303030;
  font-size: 12px;
  margin-top: 2px;
  margin-left: 10px;
}

.ticket-use {
  font-size: 16px;
  color: #e95060;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 10px;
  top: 10px;
}

.loading {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
}

.spinner {
  width: 60px;
  height: 60px;
  position: relative;
  margin: 100px auto;
}

.double-bounce1,
.double-bounce2 {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: #67cf22;
  opacity: 0.6;
  position: absolute;
  top: 0;
  left: 0;
  -webkit-animation: bounce 2s infinite ease-in-out;
  animation: bounce 2s infinite ease-in-out;
}

.double-bounce2 {
  -webkit-animation-delay: -1s;
  animation-delay: -1s;
}

@-webkit-keyframes bounce {
  0%,
  100% {
    -webkit-transform: scale(0);
  }
  50% {
    -webkit-transform: scale(1);
  }
}

@keyframes bounce {
  0%,
  100% {
    transform: scale(0);
    -webkit-transform: scale(0);
  }
  50% {
    transform: scale(1);
    -webkit-transform: scale(1);
  }
}

.confirm {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.1);
}

.confirm-main {
  width: 400px;
  height: 200px;
  background: rgba(255, 255, 255, 1);
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 1000;
  margin-left: -200px;
  margin-top: -125px;
  border-radius: 15px;
  overflow: hidden;
}

.confirm-active {
  height: 230px;
}

.confirm-main-title {
  font-size: 26px;
  text-align: center;
  color: #000000;
  margin-top: 25px;
}

.title-desc {
  font-size: 22px;
  text-align: center;
  color: #000000;
  margin-top: 15px;
}

.buttons {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 1000;
  display: flex;
}

.button-left {
  width: 50%;
  line-height: 50px;
  color: red;
  text-align: center;
  border-top: 1px solid #cccccc;
}

.button-right {
  width: 50%;
  line-height: 50px;
  color: #000000;
  text-align: center;
  border-top: 1px solid #cccccc;
  border-left: 1px solid #cccccc;
}

.order-box {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.8);
  z-index: 5000;
}

.order {
  width: 756px;
  height: 530px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #ffffff;
}

.order-top {
  width: 100%;
  height: 150px;
  border-bottom: 1px solid #cccccc;
  overflow: hidden;
}

.order-top-title {
  width: 285px;
  margin: 25px auto 0;
  display: flex;
  align-items: center;
}

.order-title-img {
  width: 62px;
  height: 62px;
}

.order-title-text {
  font-size: 48px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(17, 17, 17, 1);
  margin-left: 19px;
}

.order-subtitle {
  font-size: 28px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(110, 110, 110, 1);
  text-align: center;
}

.order-main {
  width: 756px;
  margin-top: 20px;
}

.order-line {
  width: 94%;
  line-height: 60px;
  border-bottom: 1px solid rgba(220, 218, 218, 1);
  overflow: hidden;
  margin: 0 auto;
}

.order-name {
  float: left;
  font-size: 24px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(88, 88, 88, 1);
}

.order-name-text {
  float: right;
  font-size: 24px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(17, 17, 17, 1);
}

.order-button {
  width: 154px;
  line-height: 60px;
  border: 2px solid rgba(219, 162, 86, 1);
  border-radius: 4px;
  text-align: center;
  font-size: 28px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(219, 162, 86, 1);
  position: absolute;
  bottom: 28px;
  right: 23px;
}

.get-today-consume-cetail {
  width: 150px;
  text-align: center;
  padding: 10px 20px;
  border: 1px solid rgba(219, 162, 86, 1);
  border-radius: 21px;
  color: #dba256;
  box-sizing: border-box;
  position: fixed;
  left: 30px;
  top: 30px;
  z-index: 1000;
}

.get-today-consume-cetail:hover {
  color: #000000;
  background: #dba256;
  transition: 0.5s all;
}

.today-consume-cetail {
  position: fixed;
  top: 0;
  bottom: 0;
  z-index: 4000;
  width: 800px;
  height: 100vh;
  overflow: scroll;
  transform: translateX(-800px);
  transition: 0.5s all;
  background: rgba(0, 0, 0, 0.5);
}

.today-consume-cetail-active {
  transform: translateX(800px);
  transition: 0.5s all;
}

.today-consume-title {
  color: #ffffff;
  font-size: 30px;
  text-align: center;
  margin-top: 30px;
}

.today-consume-header,
.today-consume-body {
  width: 760px;
  margin: 20px auto 0;
  background: rgba(255, 255, 255, 1);
  display: flex;
  height: 50px;
  border-bottom: 1px solid #cccccc;
}

.today-consume-content {
  height: 80vh;
  overflow: scroll;
}

.today-consume-body {
  margin: 0 auto;
}

.today-consume-header p,
.today-consume-body p {
  width: 140px;
  line-height: 50px;
  font-size: 22px;
  text-align: center;
}

.today-consume-body p {
  font-size: 18px;
}

.today-consume-body p:nth-of-type(1),
.today-consume-header p:nth-of-type(1) {
  width: 240px;
}

.today-consume-body p:nth-of-type(2),
.today-consume-header p:nth-of-type(2) {
  width: 130px;
}

.today-consume-body p:nth-of-type(3),
.today-consume-header p:nth-of-type(3) {
  width: 200px;
}

.today-consume-body p:nth-of-type(4),
.today-consume-header p:nth-of-type(4) {
  width: 180px;
}

.today-consume-close {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 1px solid #ffffff;
  position: absolute;
  top: 20px;
  right: 30px;
  font-size: 28px;
  color: #ffffff;
  line-height: 50px;
  text-align: center;
}

.today-consume-cetail-active {
  transform: translateX(0);
  transition: all 0.5s;
}
</style>



// WEBPACK FOOTER //
// src/components/restaurant.vue